/**
 * 全局色板。渲染层只允许引用这里的十六进制值，禁止裸写颜色字符串。
 * 极简几何风：象牙底、主墨、赤陶橙强调。
 */

export const PALETTE = {
  /** 象牙底 */
  ivory: '#F4F0E8',
  /** 主墨 */
  ink: '#191919',
  /** 赤陶橙（强调） */
  terracotta: '#D97757',

  /** 语义色 */
  hp: '#C7483B',
  hpBack: 'rgba(25,25,25,0.12)',
  xp: '#C99A2E',
  shield: '#4C7D9E',
  heal: '#5C8A50',
  flash: '#FFFFFF',

  /** 怪物 */
  chaser: '#191919',
  charger: '#5B4636',
  spitter: '#3F5E5A',
  bomberCap: '#D97757',
  bomberStem: '#191919',
  warn: '#C7483B',
  tired: '#8A8178',

  /** 宝石 / 粒子 */
  gem: '#C99A2E',
  particleInk: '#191919',
  particleTerracotta: '#D97757',
  particleGold: '#C99A2E',
  explosionRing: '#D97757',

  /** 网格 / 背景装饰 */
  gridLine: 'rgba(25,25,25,0.055)',
} as const;

export type PaletteColor = keyof typeof PALETTE;
